<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      label-position="left"
      label-width="100px"
    >
      <carrier ref="carrier" class="mt-2" :v_formData="radioSelectedRow" />
      <order ref="order" :listData="orderList" v-show="0" />
    </el-form>
    <div class="dialog-footer mt-3 d-flex justify-content-end">
      <el-button @click="close()" size="small">
        取消
      </el-button>
      <el-button type="success" @click="submit()" size="small"
        >确认调度</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    orderList: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Carrier: () => import('../components/carrier/manyCarrier'),
    Order: () => import('../components/order'),
  },
  data() {
    return {
      loading: false,
      tableHeight: 120,
      tableData: [],
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: '选择',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'radio',
        },
        {
          title: '合同编号',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '140',
          field: 'contractCarrierNo',
        },
        {
          title: '合同名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          minWidth: '150',
          field: 'contractCarrierName',
          slots: {
            default: 'contractCarrierName',
          },
        },
        {
          title: '始发地',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '120',
          field: 'pickupPointText',
        },
        {
          title: '目的地',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '120',
          field: 'receivingPointText',
        },
        {
          title: '运费',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'carrierFreight',
        },
        {
          title: '附加费',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'carrierFee',
          slots: {
            default: 'carrierFee',
          },
        },
        {
          title: '合同总价',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'carrierAmount',
        },
        {
          title: '承运商',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'carrierShortName',
        },
        {
          title: '计费方式',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'chargeUnitName',
        },
        {
          title: '时效',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'lineTime',
        },
        {
          title: '车型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'vehicleModelName',
        },
        {
          title: '车长',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'vehicleLengthName',
        },
        {
          title: '载重',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'vehicleLoad',
        },
        {
          title: '载方',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'vehicleVolume',
        },
      ],
      formData: {},
      contractList: [],
      selectTransportMode: { type: 'transportMode' },
      selectVehicleModel: { type: 'vehicleModel' },
      selectVehicleLength: { type: 'vehicleLength' },
      regionShow: false,
      dialogOption: {
        title: '新增',
        dialogVisible: false,
      },
      radioSelectedRow: {},
    }
  },
  watch: {
    orderList: {
      handler(orderList) {
        if (orderList) {
          this.load()
        }
      },
      immediate: true,
    },
  },
  created() {
    this.regionShow = true
  },
  methods: {
    load() {
      this.formData = this.orderList[0]
      this.getData()
    },
    async matchContract() {
      // 获取当前选择的承运商
      let carrierCode = await this.$refs.carrier.getCurCarrierCode()
      this.getData(carrierCode)
    },
    getData() {
      let totQty = 0
      let totInWeight = 0
      let totInVolume = 0
      let totPayWeight = 0
      let totPayVolume = 0
      let totValue = 0

      this.orderList.forEach((item) => {
        let qyt = item.totQty
        let inWeight = item.totInWeight
        let inVolume = item.totInVolume
        let payWeight = item.totPayWeight
        let payVolume = item.totPayVolume
        let value = item.totValue
        totQty = totQty + qyt
        totInWeight = totInWeight + inWeight
        totInVolume = totInVolume + inVolume
        totPayWeight = totPayWeight + payWeight
        totPayVolume = totPayVolume + payVolume
        totValue = totValue + value
      })
      this.loading = true
      this.tableData = []
    },
    showFeeDetail(row) {
      if (!row.feeList) {
        return
      }
      let feeList = row.feeList
      let content = ''
      feeList.forEach((item) => {
        let feeNameText = item.feeNameText
        let basePrice = item.basePrice
        content +=
          '<strong>' + feeNameText + '：<i>' + basePrice + '</i></strong><br/>'
      })
      this.$alert(content, '费用明细', {
        dangerouslyUseHTMLString: true,
      })
    },
    async submit() {
      const getCarrierData = await this.$refs.carrier.getCarrierData()
      if (!getCarrierData) {
        return
      }
      const getOrderList = await this.$refs.order.getTableData()
      if (getOrderList.length < 1) {
        this.$alert('订单列表为空，请先选择调度订单', '提示信息')
        return
      }
      let params = {}
      params = {
        ...this.formData,
        ...getCarrierData,
        listOrder: getOrderList,
      }
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .bizDispatchPoolSetManyCarrierSubmitApi(params)
        .then((res) => {
          loadingInstance.close()
          this.saveOk()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    close() {
      this.$emit('close')
    },
    saveOk() {
      this.$emit('saveOk')
    },
    radioChangeEvent({ newValue }) {
      this.radioSelectedRow = newValue
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 16px;
  font-weight: 500;
  color: #606266;
}
</style>
